import { render, staticRenderFns } from "./BannerAdvanceTemplate.vue?vue&type=template&id=bb58d2fa&scoped=true&"
import script from "./BannerAdvanceTemplate.vue?vue&type=script&lang=js&"
export * from "./BannerAdvanceTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BannerAdvanceTemplate.vue?vue&type=style&index=0&id=bb58d2fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb58d2fa",
  null
  
)

export default component.exports